import createPersistedState from 'vuex-persistedstate'
import Vue from 'vue'
import Vuex from 'vuex'



Vue.use(Vuex)

export default new Vuex.Store({
    
    state:{
        load: true,
        menu: [],
        layout:false,   //别的页面刷新 layout.vue
        token:'',
        image:'',
        guid:'',
        name:'',
        mobile:'',
        password:'',

        checkGuid:'',
        checkGuid2:'',

        vCropper: 0     //有多个 vue-cropper ，识别哪个在启用

    },
    getters:{
        is_change_load(state){
            return state.load
        },
        is_change_menu(state){
            return state.menu
        },
        is_change_layout(state){
            return state.layout
        },
        is_change_token(state){
            return state.token
        },
        is_change_image(state){
            return state.image
        },
        is_change_guid(state){
            return state.guid
        },
        is_change_name(state){
            return state.name
        },
        is_change_mobile(state){
            return state.mobile
        },
        is_change_password(state){
            return state.password
        },
        is_change_checkGuid(state){
            return state.checkGuid
        },
        is_change_checkGuid2(state){
            return state.checkGuid2
        },
        is_change_vCropper(state){
            return state.vCropper
        },
    },
    mutations:{
        change_load(state, data){
            state.load = data   
        },
        change_menu(state, data){
            state.menu = data   
        },
        change_layout(state, data){
            state.layout = data   
        },
        change_token(state, data){
            state.token = data   
        },
        change_image(state,data){
            state.image = data
        },
        change_guid(state,data){
            state.guid = data
        },
        change_name(state,data){
            state.name = data
        },
        change_mobile(state,data){
            state.mobile = data
        },
        change_password(state,data){
            state.password = data
        },
        change_checkGuid(state,data){
            state.checkGuid = data
        },
        change_checkGuid2(state,data){
            state.checkGuid2 = data
        },
        change_vCropper(state,data){
            state.vCropper = data
        }
    },
    // 缓存插件
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
  
})